import { render, staticRenderFns } from "./APIIntegration.vue?vue&type=template&id=5018cc1c&"
import script from "./APIIntegration.vue?vue&type=script&lang=js&"
export * from "./APIIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports